import request from '@/utils/request'

const apis = {
    //GET_LESSON_SUPERVISED_INFO: '/lesson/getOnlineLessonStudyInfo',
    GET_LESSON_SUPERVISED_INFO: '/lesson/onlineLessonStudyRecord/getStudentCurrentLessonSupervisedInfo',
    SUBMIT_LESSON_SUPERVISED_RESULT:  '/lesson/onlineLessonStudySupervised/submitSdtCurtLessonSupervisedResult',
    MODIFY_LESSON_LEARNING_REVIEW:  '/lesson/onlineLessonStudyRecord/modifyLessonLearningReview',
    START_NEWLESSON_LEARNING:  '/lesson/onlineLessonStudyRecord/startLearning',
    SUBMIT_ONLINE_MANUAL_SUPERVISED_RESULT:'/lesson/onlineLessonStudySupervised/submitOnlieManualSupervisionByStudent',
    CHECKCANONLINESTUDY4STUDENT:'/school/group/checkCanOnlineStudy4Student',
    GET_COURSE_REGULATION:'/lesson/getCourseRegulation',

}

export default {

    // 信息列表
    startNewLessonLearning(data) {
        let dt = data || {};
        return request.post(apis.START_NEWLESSON_LEARNING, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 信息列表
    //每次调用都会改变joinClasscode验证字符串，一旦改变下次提交modifyPlaybackTime数据必须更新，否则会触发数据校验失败，用户被踢出登录，
    getLessonSupervisedInfo(data) {
        let dt = data || {};
        return request.post(apis.GET_LESSON_SUPERVISED_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 信息列表
    modifyLessonLearningReview(data) {
        let dt = data || {};
        return request.post(apis.MODIFY_LESSON_LEARNING_REVIEW, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 信息列表
    submitLessonSupervisedResult(data) {
        let dt = data || {};
        return request.post(apis.SUBMIT_LESSON_SUPERVISED_RESULT, dt.params, {
            headers: dt.headers || {}
        });
    },
    submitOnlieManualSupervisionByStudent(data) {
        let dt = data || {};
        return request.post(apis.SUBMIT_ONLINE_MANUAL_SUPERVISED_RESULT, dt.params, {
            headers: dt.headers || {}
        });
    },
    checkCanOnlineStudy4Student(data) {
        let dt = data || {};
        return request.post(apis.CHECKCANONLINESTUDY4STUDENT, dt.params, {
            headers: dt.headers || {}
        });
    },
    getCourseRegulation(data) {
        let dt = data || {};
        return request.post(apis.GET_COURSE_REGULATION, dt.params, {
            headers: dt.headers || {}
        });
    },

}




// WEBPACK FOOTER //
// ./src/api/supervised.js